const SIDEBAR_WIDTH_KEY = "photo-manager-sidebar-width";
const DEFAULT_SIDEBAR_WIDTH = 290;
const MIN_SIDEBAR_WIDTH = 120;

export class LocalStorageHelper {
  static getSavedSidebarWidth(): number {
    try {
      const saved = localStorage.getItem(SIDEBAR_WIDTH_KEY);
      const parsedWidth = saved ? parseInt(saved, 10) : DEFAULT_SIDEBAR_WIDTH;
      const width = Number.isFinite(parsedWidth)
        ? parsedWidth
        : DEFAULT_SIDEBAR_WIDTH;
      return Math.max(MIN_SIDEBAR_WIDTH, width);
    } catch {
      return DEFAULT_SIDEBAR_WIDTH;
    }
  }

  static setSidebarWidth(width: number): void {
    try {
      localStorage.setItem(SIDEBAR_WIDTH_KEY, width.toString());
    } catch {
      // localStorage not available, ignore
    }
  }
}
